
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForexHeader.css";

import {
  collection,
  query,
  where,
  onSnapshot,
  limit,
} from "firebase/firestore";

import { db } from "../firebase";

const ForexHeader = () => {
  const navigate = useNavigate();

  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showAccounts, setShowAccounts] = useState(false);
  const [switchLoading, setSwitchLoading] = useState(false);

  // Idadi ya notifications ambazo hazijasomwa
  const [unreadCount, setUnreadCount] = useState(0);

  // =========================================
  // LOAD USER BALANCE FROM FIREBASE
  // =========================================
  useEffect(() => {
    const username = localStorage.getItem("username");

    if (!username) {
      setBalance(null);
      setLoading(false);
      return;
    }

    const usersQuery = query(
      collection(db, "users"),
      where("username", "==", username),
      limit(1)
    );

    const unsubscribe = onSnapshot(
      usersQuery,
      (snapshot) => {
        if (snapshot.empty) {
          setBalance(null);
          setLoading(false);
          return;
        }

        const userData = snapshot.docs[0].data();
        const amount = Number(userData.usdtBalanceOther);

        setBalance(
          Number.isFinite(amount) ? amount : 0
        );

        setLoading(false);
      },
      (error) => {
        console.error("Balance error:", error);
        setBalance(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // =========================================
  // LOAD UNREAD NOTIFICATIONS REAL-TIME
  // Mfumo ule ule unaotumika kwenye Header.jsx
  // =========================================
  useEffect(() => {
    const username = localStorage.getItem("username");

    if (!username) {
      setUnreadCount(0);
      return;
    }

    const notificationsQuery = query(
      collection(db, "notifications"),
      where("username", "==", username)
    );

    const unsubscribe = onSnapshot(
      notificationsQuery,
      (snapshot) => {
        let count = 0;

        snapshot.forEach((notificationDoc) => {
          const notificationData = notificationDoc.data();

          // Notification haijasomwa ikiwa read si true
          if (notificationData.read !== true) {
            count += 1;
          }
        });

        setUnreadCount(count);
      },
      (error) => {
        console.error("Unread notifications error:", error);
        setUnreadCount(0);
      }
    );

    return () => unsubscribe();
  }, []);

  // =========================================
  // FORMAT BALANCE
  // =========================================
  const formattedBalance =
    balance === null
      ? "—"
      : balance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  // =========================================
  // NAVIGATION
  // =========================================
  const goToDeposit = () => {
    setShowAccounts(false);
    navigate("/DepisitBFCOrder");
  };

  const goToWithdraw = () => {
    setShowAccounts(false);
    navigate("/withdraw");
  };

  const goToDashboard = () => {
    setShowAccounts(false);
    navigate("/dashboard");
  };

  const goToNotifications = () => {
    setShowAccounts(false);
    navigate("/notifications");
  };

  // =========================================
  // ACCOUNT BUTTON
  // =========================================
  const handleAccountClick = () => {
    if (switchLoading) return;

    setShowAccounts(false);
    setSwitchLoading(true);

    setTimeout(() => {
      setSwitchLoading(false);
    }, 1500);
  };

  // =========================================
  // HEADER
  // =========================================
  return (
    <div className="forex-sticky-header">
      <div className="forex-account-header">

        {/* HOME BUTTON */}
        <button
          type="button"
          className="forex-back-btn forex-home-btn"
          onClick={goToDashboard}
          aria-label="Go to Dashboard"
          title="Home"
        >
          <svg
            viewBox="0 0 24 24"
            width="23"
            height="23"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M3 10.5 12 3l9 7.5" />
            <path d="M5.5 9.5V21h13V9.5" />
            <path d="M9.5 21v-7h5v7" />
          </svg>
        </button>

        {/* BFC LOGO */}
        <div className="forex-brand">
          <div className="forex-brand-main">
            BFC
          </div>

          <div className="forex-brand-small">
            B.F.C MARKETS
          </div>
        </div>

        {/* ACCOUNT BALANCE */}
        <div className="forex-account-wrapper">
          <button
            type="button"
            className="forex-account"
            onClick={() => {
              if (!switchLoading) {
                setShowAccounts((previous) => !previous);
              }
            }}
            aria-label="Open account menu"
            aria-expanded={showAccounts}
          >
            <span className="forex-demo">
              Real
            </span>

            <strong className="forex-account-balance">
              {loading
                ? "Loading..."
                : balance === null
                  ? "Unavailable"
                  : `$${formattedBalance}`}
            </strong>

            <span className="forex-account-arrow">
              {showAccounts ? "⌃" : "⌄"}
            </span>

            <span className="forex-account-line" />
          </button>

          {/* ACCOUNT MENU */}
          {showAccounts && (
            <div className="forex-account-menu">
              <div className="forex-menu-title">
                Select Account
              </div>

              {/* DEMO ACCOUNT */}
              <button
                type="button"
                className="forex-menu-option"
                onClick={handleAccountClick}
              >
                <span className="forex-menu-dot" />

                <span className="forex-menu-account-info">
                  <strong>Demo Account</strong>
                  <small>Practice account</small>
                </span>

                <span className="forex-menu-arrow">›</span>
              </button>

              {/* DEPOSIT */}
              <button
                type="button"
                className="forex-menu-option"
                onClick={goToDeposit}
              >
                <span>💰</span>

                <span className="forex-menu-account-info">
                  <strong>Deposit</strong>
                  <small>Add funds to your account</small>
                </span>

                <span className="forex-menu-arrow">›</span>
              </button>

              {/* WITHDRAW */}
              <button
                type="button"
                className="forex-menu-option"
                onClick={goToWithdraw}
              >
                <span>💸</span>

                <span className="forex-menu-account-info">
                  <strong>Withdraw</strong>
                  <small>Withdraw your funds</small>
                </span>

                <span className="forex-menu-arrow">›</span>
              </button>
            </div>
          )}

          {/* SWITCH LOADING */}
          {switchLoading && (
            <div
              className="forex-switch-loading"
              role="status"
              aria-live="polite"
            >
              <span className="forex-loading-spinner" />
              <span>Switch Account...</span>
            </div>
          )}
        </div>

        {/* QUICK DEPOSIT */}
        <button
          type="button"
          className="forex-quick-deposit"
          onClick={goToDeposit}
        >
          Deposit
        </button>

        
{/* NOTIFICATION */}
<button
  type="button"
  className="forex-notification"
  aria-label={
    unreadCount > 0
      ? `${unreadCount} unread notifications`
      : "Notifications"
  }
  onClick={goToNotifications}
>
  <span
    className="forex-notification-icon"
    aria-hidden="true"
  >
    🔔
  </span>

  {unreadCount > 0 && (
    <span className="forex-notification-badge">
      {unreadCount > 9 ? "9+" : unreadCount}
    </span>
  )}
</button>


      </div>
    </div>
  );
};

export default ForexHeader;
